import RequestAdapter from '../adapters/RequestAdapter';
import { API_V3_PATH_BASE } from '../constants';
import { ENDPOINTS } from '../enums/endpoints';

/**
 * Get a list of users
 *
 * @function
 *
 * @param {object} params
 *
 * @returns {object} JSON response
 */
const getAll = async (params) => {
  const requestConfig = {
    url: `${API_V3_PATH_BASE}${ENDPOINTS.ACCOUNT_USERS.LIST}?${params}`,
    method: 'GET',
  };

  return await RequestAdapter.request(requestConfig);
};

/**
 * Update User
 *
 * @function
 *
 * @param {object} formData
 *
 * @returns {object} JSON response
 */
const update = async (formData) => {
  const { userId, ...data } = formData;
  const requestConfig = {
    url: `${API_V3_PATH_BASE}${ENDPOINTS.ACCOUNT_USERS.EDIT(userId)}`,
    method: 'PUT',
    body: JSON.stringify({
      user: { ...data },
    }),
  };

  return await RequestAdapter.request(requestConfig);
};

/**
 * Create User
 *
 * @function
 *
 * @param {object} formData
 *
 * @returns {object} JSON response
 */
const create = async (formData) => {
  const { userId, ...data } = formData;

  const requestConfig = {
    url: `${API_V3_PATH_BASE}${ENDPOINTS.ACCOUNT_USERS.CREATE}`,
    method: 'POST',
    body: JSON.stringify({
      user: { ...data },
    }),
  };

  return await RequestAdapter.request(requestConfig);
};

/**
 * Delete one or more user
 *
 * @function
 *
 * @param {string} userId
 *
 * @returns {object} JSON response
 */
const deleteAll = async (userId) => {
  const requestConfig = {
    url: `${API_V3_PATH_BASE}${ENDPOINTS.ACCOUNT_USERS.EDIT(
      userId.toString()
    )}`,
    method: 'DELETE',
  };

  return await RequestAdapter.request(requestConfig);
};

const getUserAccounts = async (userId) => {
  const requestConfig = {
    url: `${API_V3_PATH_BASE}${ENDPOINTS.USER.USER_ACCOUNTS(
      userId.toString()
    )}`,
    method: 'GET',
  };

  return await RequestAdapter.request(requestConfig);
};

const changeCurrentAccount = async (userId, accountId) => {
  const requestConfig = {
    url: `${API_V3_PATH_BASE}${ENDPOINTS.USER.CHANGE_CURRENT_ACCOUNT(
      userId.toString()
    )}`,
    body: JSON.stringify({
      change_account_to: accountId,
    }),
    method: 'PUT',
  };

  return await RequestAdapter.request(requestConfig);
};

export const UserService = {
  getAll,
  update,
  create,
  deleteAll,
  getUserAccounts,
  changeCurrentAccount,
};
